<div class="row mt-auto mb-auto">
  <div class="col-12">

      <!-- <div class="row mb-4">
          <p class="col-md-10 col-xs-12 mx-auto">
            Welcome to our integration page.  This page details all of our currently available standard integrations.  To view an integration, click on the integration itself to view what it does, how it works and what you need to provide.
          </p>
      </div> -->

      <!-- <div class="row mb-2">
        <h2>Authentification and User management</h2>
      </div> -->

      <div class="row mb-2" *ngIf="!loading">
       <!-- <div class="card" style="max-width: 26rem;">
          <img class="card-img-top" src="assets/images/p2a.jpg" alt="Card image cap"> -->
          <!-- <div class="card-header">Azure Active Directory </div> -->
        <!-- <div class="card-body">
            <h5 class="card-title">P2A</h5>
            <p class="card-text">{{ 'pages.updates.certTools.p2aDesc' | translate }}</p>
            <div class="row justify-content-between">
              <a href="/updates/services/certtools" class="btn btn-primary">{{ 'pages.updates.certTools.scanFile' | translate }}</a>
              <p>{{ 'pages.updates.certTools.quotaStatus' | translate }}</p>
            </div>
          </div>
        </div> -->

        <div class="card" style="max-width: 26rem;">
          <img class="card-img-top" src="assets/images/vital.png" alt="Card image cap">
          <!-- <div class="card-header">Azure Active Directory </div> -->
          <div class="card-body">
            <h5 class="card-title">Vital</h5>
            <p class="card-text">{{ 'pages.updates.certTools.vitalDesc' | translate }}</p>
            <div class="row justify-content-between">
              <a href="/updates/services/certtools/vitalupload" class="btn btn-primary" *ngIf="vitalQuota > 0">{{ 'pages.updates.certTools.scanFile' | translate }}</a>
              <a href="/updates/services/certtools/vitalupload" class="btn btn-primary disabled" *ngIf="vitalQuota == null || vitalQuota <= 0">{{ 'pages.updates.certTools.scanFile' | translate }}</a>
              <p *ngIf="vitalQuota != null">{{ 'pages.updates.certTools.quota' | translate }} : <b>{{vitalQuota}}</b></p>
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-center p-5 mt-8" *ngIf="loading">
        <div class="spinner-border spinner-border-lg text-primary" role="status">
          <span class="sr-only">{{ 'pages.generic.loading' | translate }}</span>
        </div>
      </div>

  </div>
</div>
